export default __webpack_public_path__ + "static/pic04-96bf03ab3da9b3c40459d5e08a6def5a.jpg";